<div *ngIf="newsletterContent.MenuLocation != 'None'" [class]="newsletterContent.MenuLocation == 'Left' ? 'NEWSLETTER_TAB_POSITION' : 'NEWSLETTER_TAB_POSITION topMenu'">
    <a class="menu-icon" (click)="openNewsletterTab()">
        <i class="fa fa-bars"></i>
         {{newsletterContent.HamburgerText}}
    </a>
    <div [ngClass]="expandMenu ? 'mobileMenu' : 'desktopMenu'" >
        @for (menuItem of menuItems(); track menuItem) {
            <div (click)="handleNavigate(menuItem)" [ngClass]="{ active: menuItem.active }"
                [class]="newsletterContent.MenuLocation == 'Top' ? 'DTX_BUTTON_TAB centreTabText': 'DTX_BUTTON_TAB leftTabText'">
                <app-title class="DTX_NEWSLETTER_TITLE" [contentTitle]="menuItem.IndexTitle ?? menuItem.Title ?? ''" />
            </div>
        }
    </div>
</div>
